var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E8F3FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.691,
    cy: 14.666,
    transform: "rotate(120 13.69 14.666)",
    fill: "#3C83E1",
    r: 1.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.488 15.03a1.25 1.25 0 01.457 1.708l-3.333 5.774a1.25 1.25 0 01-1.707.457l-7.795-4.5a1.25 1.25 0 01-.616-.933L9.996 13.4a1.25 1.25 0 01.75-1.299l3.832-1.636a1.25 1.25 0 011.116.067l7.794 4.5z",
    stroke: "#3C83E1",
    strokeWidth: 1.5
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNFOEYzRkUiLz4KPGVsbGlwc2UgY3g9IjEzLjY5MDYiIGN5PSIxNC42NjY1IiByeD0iMS4zMzMzMyIgcnk9IjEuMzMzMzMiIHRyYW5zZm9ybT0icm90YXRlKDEyMCAxMy42OTA2IDE0LjY2NjUpIiBmaWxsPSIjM0M4M0UxIi8+CjxwYXRoIGQ9Ik0yMy40ODc5IDE1LjAzMDZDMjQuMDg1OCAxNS4zNzU4IDI0LjI5MDYgMTYuMTQwMyAyMy45NDU1IDE2LjczODJMMjAuNjEyMSAyMi41MTE3QzIwLjI2NjkgMjMuMTA5NSAxOS41MDI1IDIzLjMxNDQgMTguOTA0NiAyMi45NjkyTDExLjExMDQgMTguNDY5MkMxMC43Njk2IDE4LjI3MjUgMTAuNTQxNCAxNy45MjY4IDEwLjQ5NDMgMTcuNTM2Mkw5Ljk5NTk0IDEzLjM5OTRDOS45Mjk0OCAxMi44NDc5IDEwLjIzNSAxMi4zMTg2IDEwLjc0NTkgMTIuMTAwNEwxNC41Nzc3IDEwLjQ2MzZDMTQuOTM5NSAxMC4zMDkxIDE1LjM1MyAxMC4zMzM5IDE1LjY5MzcgMTAuNTMwNkwyMy40ODc5IDE1LjAzMDZaIiBzdHJva2U9IiMzQzgzRTEiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPg==";
export { SvgContactSales as ReactComponent };